<template>
    <v-dialog v-model="firstLoginPopup" persistent max-width="586px" class="modal">
      <v-card>
        <v-card-title class="headline">
                <a v-on:click='closeModal' class="right"> <span class="icon-close right"></span> </a>
                <span class="cardheader">{{dialogHeader}}</span>
                <span class="cardsubheader">{{$t('Login.FirstTimeLogin.WHAT_DO_YOU_WANT_TO_DO_DESC')}}</span>
         </v-card-title>

        <v-card-text class="cardfirstlogin">
            <div class="listcard">
                <div class="carditem" v-for="card in cards" :key="card.id" v-on:click='redirect(card.link,card.isExternalLink)'>
                    <span class="cardimage">
                     <v-img :src="card.imageUrl" class="cardimage"></v-img>
                    </span>
                    <span class="cardtext">
                        <p class="cardtitle">
                            {{card.titleText}}
                        </p>
                        <p class="subtitledescription">
                             {{card.subTitleText}}
                        </p>
                    </span>

                </div>
                <div class="checkboxpopup">
                    <v-checkbox v-model="checkShowPopup" @change="onFirstTimeLoginChange" color="primary" :label="$t('Login.FirstTimeLogin.DONT_SHOW_AGAIN_DESC')"></v-checkbox>
                </div>
         </div>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import auth from '@/services/Auth'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      dialogHeader: `Welcome on the ${process.env.VUE_APP_NODE_ENV_API} portal`,
      checkShowPopup: false,
      cards: [
        {
          id: 1,
          imageUrl: require(`@/assets/img/${process.env.VUE_APP_NODE_ENV_API}/apidoc.svg`),
          titleText: this.$t('Login.FirstTimeLogin.API_DOCUMENTATION_CARD_TITLE'),
          subTitleText: this.$t('Login.FirstTimeLogin.API_DOCUMENTATION_CARD_DESC'),
          link: 'doc',
          isExternalLink: true
        },
        {
          id: 2,
          imageUrl: require(`@/assets/img/${process.env.VUE_APP_NODE_ENV_API}/apikeys.svg`),
          titleText: this.$t('Login.FirstTimeLogin.API_KEY_CARD_TITLE'),
          subTitleText: this.$t('Login.FirstTimeLogin.API_KEY_CARD_DESC'),
          link: 'apikeys',
          isExternalLink: false
        }

      ],
      snackbar: {
        show: false,
        color: 'success',
        text: this.$t('Login.FirstTimeLogin.SUCCESSFUL_ACTION_SAVE_DESC'),
        timeout: 6000
      }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('global/setFirstLoginPopup', false)
    },
    async onFirstTimeLoginChange () {
      let succeded = false
      await auth.changeStatusFirstLoginPopup().then((result) => {
        succeded = result
      }).catch((err) => {
        console.log(err)
        succeded = false
      })

      if (succeded) {
        this.snackbar.show = true
        this.$store.dispatch('global/setSnackbar', this.snackbar)
      }
    },
    redirect (linkName, isExternalLink) {
      if (isExternalLink) {
        let linkurl = linkName.toUpperCase() === 'doc'.toUpperCase() ? this.config.docUrl : linkName
        window.open(linkurl, '_blank')
      } else {
        this.$router.push({ name: linkName })
        this.$store.dispatch('global/setFirstLoginPopup', false)
      }
    }
  },
  mounted () {
    let userInfo = auth.getUserInfos()
    if (userInfo) {
      this.dialogHeader = this.$t('Login.FirstTimeLogin.FIRST_TIME_LOG_IN_POPUP_TITLE', { useFirstName: `${userInfo.firstName}` })
    }
  },
  computed: {
    ...mapState('global', ['firstLoginPopup']),
    ...mapState('siteconfig', ['config'])
  }

}
</script>
